import React from 'react';
import SearchResult from './SearchResult';
import "../styles/SearchResultsSection.css";

const SearchResultsSection = ({ searchResults, handleSelectActor, connectedActors, actorPair }) => {
  const connectedActorNames = new Set(connectedActors.map(actor => actor.name));
  if (actorPair) {
    connectedActorNames.add(actorPair.actor_1.name);
    connectedActorNames.add(actorPair.actor_2.name);
  }
  

  const filteredResults = searchResults.filter(actorName => (!connectedActorNames.has(actorName)));

  return (
      <div className="search-results-container">
        {filteredResults.length > 0 && (
          <div className="search-results-outline">
            {filteredResults.map((actorName, index) => (
              <SearchResult key={index} index={index} actorName={actorName} handleSelectActor={handleSelectActor} />
            ))}
          </div>
        )}
      </div>
  );
};

export default SearchResultsSection;